import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/697501e81beda800144c3e2b_1787870571226_a45365b5/danny_clans_media/node_modules/next/dist/client/app-dir/link.js");
